import React from 'react';
import { injectIntl } from 'react-intl';
import Dropdown from 'components/dropdown/dropdown';
import Ellipse from 'utils/ellipse';
import messages from './messages';

class NavUserDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.onLogout();
  }

  determineTriggerText() {
    if (!this.props.user) return '';

    const { intl, user: { name, email } } = this.props;
    return name ? intl.formatMessage(messages.greeting_label, { name: name }) : Ellipse(email, 13);
  }

  render() {
    const triggerTxt = this.determineTriggerText();
    const buttonOptions = this.props.sessionLinks.filter(link => {
      return link.action !== undefined;
    });
    const linkOptions = this.props.sessionLinks.filter(link => {
      return link.path !== undefined;
    });

    return (
      <Dropdown
        animate="bottomRight"
        plainTrigger
        buttonOptions={buttonOptions}
        linkOptions={linkOptions}
        theme="dark"
        triggerTxt={triggerTxt}
      />
    );
  }
}

export default injectIntl(NavUserDropdown);



// WEBPACK FOOTER //
// ./src/client/components/nav/nav-user-dropdown.jsx